export default __webpack_public_path__ + "static/media/abmatrixlogo.6243e388.png";